/*
 * @Descripttion: 教科研工作上报 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-03-13
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-03-13 18:36:03
 */

import http from '@/utils/kq/http';

const veJkyReportApi = {
  //添加接口
  add(data) {
    return http.post(http.service.jkl + 'veJkyReport/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.jkl + 'veJkyReport/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.jkl + 'veJkyReport/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.jkl + 'veJkyReport/page', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.jkl + 'veJkyReport/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.jkl + 'veJkyReport/updateStatus', data);
  }
};
export default veJkyReportApi;
